// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"_1GdgP","CardSection":"_3igjR","Ancestor":"_2PilZ","CardContent":"_1c52H","ImageContainer":"_28Qfo","Image":"_1ysY8"};